export enum CourseOutcome {
  Competent,
  NotYetCompetent,
}
